import { z } from "zod";
export const WebPaywallTriggerSchema = z.object({
    id: z.number(),
    applicationId: z.number(),
    name: z.string(),
    enabled: z.boolean().default(true),
    setupUrl: z.string(),
    urlMatchingString: z.string(),
    webPaywallId: z.number().optional(),
    elementSelector: z.string().default(""),
    elementSelectorType: z.enum([
        "CSS",
        "TEXT"
    ]),
    triggerType: z.enum([
        "ON_LOAD",
        "ON_ELEMENT_CLICK"
    ]),
    pageLoadDelayMs: z.number()
});
export const PublicWebPaywallTriggerSchema = WebPaywallTriggerSchema.omit({
    webPaywallId: true
}).extend({
    webPaywallIdentifier: z.string()
});
